import { EmployeeDataFileService } from '../employeeData/EmployeeDataFileService';

export class FirebaseEmployeeDataFileService
  implements EmployeeDataFileService {
  constructor(private readonly storage: firebase.storage.Storage) {}

  public async upload(file: File | null): Promise<void> {
    if (file === null) {
      return;
    }

    await this.storage
      .ref()
      .child(`employeeData/${file.name}`)
      .put(file);
  }
}
